export const SortOrder = {
  createdAsc: 'created:asc',
  createdAtAsc: 'createdAt:asc',
  createdDesc: 'created:desc',
  createdAtDesc: 'createdAt:desc',
  titleAsc: 'title:asc',
  titleDesc: 'title:desc',
  distanceAsc: 'distance:asc',
  distanceDesc: 'distance:desc',
  distanceAscTitleAsc: 'distance:asc,title:asc',
  lastEditedAtDesc: 'updatedAt:desc',
  sortOrderAsc: 'sortOrder:asc',
  // Soonest first, for listings of dated entries. The two indexes name the day
  // an entry happens on differently: `eventDate` on region-event, `startDate`
  // on a region-news Terminbeitrag.
  eventDateAsc: 'eventDate_timestamp:asc',
  startDateAsc: 'startDate_timestamp:asc',
  priceAsc: 'price:asc',
  // Ongoing Termine ("ganzjährig", "täglich geöffnet", …) ahead of dated ones.
  // Meili sorts on the index-only `ongoing` flag of region-event / region-news.
  ongoingFirst: 'ongoing:desc',
  // "Neueste" on the product, news (menu plans included), post, service and job
  // listings: the owner's last change, else the creation date (Meili
  // `last_edited`, derived in the backend's index configs). Not the legacy
  // SilverStripe `updated` column, empty on every row created in Strapi, and not
  // `updatedAt`, which every cron, script and webhook write bumps.
  newestDesc: 'last_edited:desc'
};
